export function getDate(): Date {
    return new Date();
}
